module.exports = __webpack_public_path__ + "static/media/yellowhead-19.8ffd6b3f.jpg";